import { styled } from '../../stitches.config';

const Nav = styled('nav', {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 0 50px',
    alignItems: 'center',
})

export default Nav;